import { fetchApi, fetchRest } from "@/config/api";
import type { SellerRegisterForm } from "@/types";

// 1) GraphQL：保存文本信息到 vendeurs 表（不含文件）
export interface SellerRegisterResponse {
  register        : {
    user          : {
      id_vendeur  : number;
      email       : string;
      nomContact  : string;
      prenomContact: string;
      nomSociete  : string;
      nomBoutique : string;
    };
    message: string;
  };
}

export async function submitSellerRegistration(
  form: SellerRegisterForm,
): Promise<SellerRegisterResponse> {
  const mutation = `
    mutation RegisterSeller($input: SellerRegisterInput!) {
      register(input: $input) {
        user {
          id_vendeur
          email
          nomContact
          prenomContact
          nomSociete
          nomBoutique
        }
        message
      }
    }
  `;

  // 把前端字段映射到后端的 InputType 字段
  console.log("form", form);
  
  const variables = {
    input: {
      email         : form.email,
      password      : form.password,
      nomContact    : form.contactName,
      prenomContact : form.firstName,
      nomSociete    : form.companyName,
      nomBoutique   : form.brand, // .join(",")
      marques       : form.brand,
      phone         : form.phone,
      mobile        : form.mobile,
      fax           : form.fax,
      siret         : form.siret,
      creationDate  : form.creationDate,
      streetAddress : form.streetAddress,
      streetNumber  : form.streetNumber,
      postalCode: form.postalCode,
      city: form.city,
      addressComplement: form.addressComplement,
      accountTitle: form.accountTitle,
      iban: form.iban,
      tva: form.vat,
      bic: form.bic || "",
      minOrder: form.minOrder,
      website: form.website,
      description: form.description,
      productCategories: form.productCategories,
      priceMin: form.priceRange.min,
      priceMax: form.priceRange.max,
    },
  };

  const res = await fetchApi<SellerRegisterResponse>(mutation, variables);
  return res;
}

// 2) REST：上传 kbis / idGerant / logo 到 registerInfo 目录
export async function uploadRegisterDocs(
  vendorId: number,
  form: SellerRegisterForm,
): Promise<void> {
  const fd = new FormData();

  if (form.kbis) {
    fd.append("kbis", form.kbis);
  }

  if (form.idGerant) {
    fd.append("idGerant", form.idGerant);
  }

  if (form.logoFile) {
    fd.append("logo", form.logoFile);
  }

  const VUE_APP_API_BASE_URL = process.env.VUE_APP_API_BASE_URL;

  const url = `${VUE_APP_API_BASE_URL}/vendors/${vendorId}/register-info`;

  await fetchRest(url, {
    method: "POST",
    body: fd,
    skipAuthRedirect: true,
  });
}

// 3) GraphQL：Vérifier si l'email existe déjà
export async function checkEmailExists(email: string): Promise<boolean> {
  const query = `
    query CheckEmailExists($email: String!) {
      checkEmailExists(email: $email)
    }
  `;

  const variables = {
    email: email.trim().toLowerCase(),
  };

  const res = await fetchApi<{ checkEmailExists: boolean }>(query, variables);
  return res.checkEmailExists;
}
